import { JwtTokenInfo, LoginState } from "@/interfaces/sdk-login";
import { actions } from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state: LoginState = {
  parsedToken: {} as JwtTokenInfo,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
